import React from 'react';
import { ASSETS } from '../data/assets';
import AssetRow from './AssetRow';
import styles from './HoursForm.module.css';

const mheAssets   = ASSETS.filter(a => a.category === 'MHE');
const otherAssets = ASSETS.filter(a => a.category !== 'MHE');

export default function HoursForm({
  rows, progress, allDone, submitted,
  setHours, setDate, toggleNA,
  savePartial, submit,
}) {
  if (submitted) {
    return (
      <div className={styles.successWrap}>
        <div className={styles.successIcon}>
          <svg viewBox="0 0 24 24" fill="none" stroke="#007a47" strokeWidth="2.5">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>
        <h2 className={styles.successTitle}>Hours Submitted!</h2>
        <p className={styles.successSub}>
          Your readings have been sent to Pacific Rim Capital.<br />
          Our team will review and follow up if anything is needed.<br /><br />
          <strong>Thank you!</strong>
        </p>
      </div>
    );
  }

  const pct = Math.round((progress.done / progress.total) * 100);

  return (
    <div className={styles.layout}>

      {/* ── MAIN ── */}
      <div className={styles.main}>

        <div className={styles.notice}>
          Enter the <strong>current hour meter reading</strong> and <strong>date</strong> for each MHE asset.
          Chargers, batteries, and accessories are pre-set to <strong>No Hours (N/A)</strong>.
        </div>

        {/* Column headers */}
        <div className={styles.colHeads}>
          <div className={styles.ch}>#</div>
          <div className={styles.ch}>Asset</div>
          <div className={`${styles.ch} ${styles.chBlue}`}>Current Hours</div>
          <div className={`${styles.ch} ${styles.chBlue}`}>Reading Date</div>
          <div className={styles.ch}>N/A</div>
        </div>

        {/* MHE group */}
        <div className={styles.group}>
          <div className={styles.groupHead}>
            <span className={styles.groupLabel}>MHE — Requires Hours</span>
            <span className={`${styles.badge} ${styles.badgeMHE}`}>
              {progress.mheDone} / {progress.mheTotal}
            </span>
          </div>
          {mheAssets.map((a, i) => (
            <AssetRow
              key={a.id}
              row={rows[a.id]}
              index={i}
              onHours={setHours}
              onDate={setDate}
              onToggleNA={toggleNA}
            />
          ))}
        </div>

        {/* Non-MHE group */}
        <div className={styles.group} style={{ marginTop: 12 }}>
          <div className={styles.groupHead}>
            <span className={styles.groupLabel}>Chargers · Batteries · Accessories</span>
            <span className={`${styles.badge} ${styles.badgeOther}`}>Pre-set N/A</span>
          </div>
          {otherAssets.map((a, i) => (
            <AssetRow
              key={a.id}
              row={rows[a.id]}
              index={mheAssets.length + i}
              onHours={setHours}
              onDate={setDate}
              onToggleNA={toggleNA}
            />
          ))}
        </div>
      </div>

      {/* ── SIDEBAR ── */}
      <aside className={styles.sidebar}>

        {/* Progress ring */}
        <div className={styles.scard}>
          <div className={styles.ringWrap}>
            <svg className={styles.ringSvg} width="96" height="96" viewBox="0 0 100 100">
              <circle className={styles.ringTrack} cx="50" cy="50" r="45" />
              <circle
                className={`${styles.ringFill} ${pct === 100 ? styles.ringComplete : ''}`}
                cx="50" cy="50" r="45"
                style={{ strokeDashoffset: 283 - (pct / 100) * 283 }}
              />
            </svg>
            <div className={styles.ringInfo}>
              <span className={styles.ringPct}>{pct}%</span>
              <div className={styles.ringSub}>{progress.done} of {progress.total} complete</div>
            </div>
          </div>
        </div>

        {/* Summary */}
        <div className={styles.scard}>
          <div className={styles.scardHead}>Summary</div>
          <div className={styles.scardBody}>
            <div className={styles.stat}>
              <span className={styles.statLabel}>MHE filled</span>
              <span className={`${styles.statVal} ${styles.statGreen}`}>{progress.mheDone} / {progress.mheTotal}</span>
            </div>
            <div className={styles.stat}>
              <span className={styles.statLabel}>Non-MHE</span>
              <span className={`${styles.statVal} ${styles.statAmber}`}>{progress.otherTotal} N/A</span>
            </div>
            <div className={styles.stat}>
              <span className={styles.statLabel}>Pending</span>
              <span className={styles.statVal}>{progress.pending > 0 ? `${progress.pending} assets` : 'None ✓'}</span>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className={styles.scard}>
          <div className={styles.scardHead}>Actions</div>
          <div className={styles.scardBody}>
            <button
              className={`${styles.btn} ${styles.btnPrimary}`}
              disabled={!allDone}
              onClick={submit}
            >
              Submit Hours →
            </button>
            <button
              className={`${styles.btn} ${styles.btnGhost}`}
              onClick={savePartial}
            >
              💾 Save Progress
            </button>
          </div>
        </div>

      </aside>
    </div>
  );
}
